import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '@mui/material';
import HostModal from '../../Modal/HostModal';
import useIsMobile from 'src/hooks/useIsMobile';
import { IVanHost } from 'src/store/reducers/host/types';

interface IProps {
  host: IVanHost;
}

const VanHost: FC<IProps> = ({ host }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { photo, first_name, last_name, host_tag } = host;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (isMobile) navigate(`/host/reviews/${host_tag[0]}`);
    else setOpen(true);
  };

  return (
    <>
      <div className='van__order__host' onClick={handleClick}>
        <Avatar alt='user photo' src={photo ?? '/broken-image.jpg'} />
        <div className='van__order__host__container'>
          <p className='van__order__host__title'>Hosted by:</p>
          <p className='van__order__host__name'>
            {`${first_name.split(' ')[0]} ${last_name.slice(0, 1)}.`}
          </p>
        </div>
      </div>
      <HostModal host={host} open={open} handleClose={() => setOpen(false)} />
    </>
  );
};
export default VanHost;
